import { html, nothing } from "lit";
import type { FleetPlanPhase } from "../types.ts";

const PHASES: { id: FleetPlanPhase; label: string }[] = [
  { id: "planning", label: "Planning" },
  { id: "execution", label: "Execution" },
  { id: "review", label: "Review" },
  { id: "final_result", label: "Final result" },
];

export function renderFleetPlanPhaseStepper(params: {
  phase: FleetPlanPhase | undefined;
  testid?: string;
}) {
  const currentIndex = PHASES.findIndex((p) => p.id === params.phase);

  return html`
    <div
      class="fleet-phase-stepper"
      role="list"
      aria-label="Plan phase"
      data-testid=${params.testid ?? "fleet-phase-stepper"}
    >
      ${PHASES.map((p, i) => {
        const isActive = i === currentIndex;
        const isCompleted = i < currentIndex;
        const cssClass = isActive
          ? "fleet-phase-stepper__step is-active"
          : isCompleted
            ? "fleet-phase-stepper__step is-completed"
            : "fleet-phase-stepper__step";
        return html`
          <div
            class=${cssClass}
            role="listitem"
            data-phase=${p.id}
            aria-current=${isActive ? "step" : nothing}
          >
            <div class="fleet-phase-stepper__dot" aria-hidden="true"></div>
            <div class="fleet-phase-stepper__label">${p.label}</div>
          </div>
        `;
      })}
    </div>
  `;
}

/**
 * Compact phase badge when horizontal stepper is too heavy.
 */
export function renderFleetPlanPhaseBadge(params: { phase: FleetPlanPhase | undefined }) {
  const label = PHASES.find((p) => p.id === params.phase)?.label ?? params.phase ?? "—";
  return html`
    <span class="pill pill--sm pill--phase" data-testid="fleet-phase-badge">${label}</span>
  `;
}
